<template>
  <div>
    <div class="l-container">
      <h1 class="m-label btn">集計</h1>
      <div class="wrapper">

        <div class="list-box">
          <table-c>
            <tr-c slot="tr-th">
              <th-c style="background: #f6fdff">期間検索</th-c>
              <th-c style="background: #f6fdff">契約日付</th-c>
              <td-c><input v-model="search.contract_date[0]" type="text" @keyup="searchTable()" placeholder="契約日付"></td-c>
              <td-c><input v-model="search.contract_date[1]" type="text" @keyup="searchTable()" placeholder="〜契約日付"></td-c>
            </tr-c>
          </table-c>
        </div>

        <div class="list-box" v-if="aggregate_contract.sendai">
          <table-c>
            <tr-c slot="tr-th">
              <td-c>項目</td-c>
              <th-c>売上</th-c>
              <th-c>%</th-c>
              <th-c>営業所売上</th-c>
            </tr-c>
            <tr-c slot="tr-th">
              <th-c>仙台</th-c>
              <td-c>{{aggregate_contract.sendai.amount.toLocaleString()}}</td-c>
              <td-c>75%</td-c>
              <td-c>{{aggregate_contract.sendai.purchase_amount.toLocaleString()}}</td-c>
            </tr-c>
            <tr-c slot="tr-th">
              <th-c>札幌</th-c>
              <td-c>{{aggregate_contract.sapporo.amount.toLocaleString()}}</td-c>
              <td-c>75%</td-c>
              <td-c>{{aggregate_contract.sapporo.purchase_amount.toLocaleString()}}</td-c>
            </tr-c>
            <tr-c slot="tr-th">
              <th-c>名古屋</th-c>
              <td-c>{{aggregate_contract.nagoya.amount.toLocaleString()}}</td-c>
              <td-c>75%</td-c>
              <td-c>{{aggregate_contract.nagoya.purchase_amount.toLocaleString()}}</td-c>
            </tr-c>
            <tr-c slot="tr-th">
              <th-c>福岡</th-c>
              <td-c>{{aggregate_contract.fukuoka.amount.toLocaleString()}}</td-c>
              <td-c>75%</td-c>
              <td-c>{{aggregate_contract.fukuoka.purchase_amount.toLocaleString()}}</td-c>
            </tr-c>
            <tr-c slot="tr-th">
              <th-c>新宿</th-c>
              <td-c>{{aggregate_contract.shinjuku.amount.toLocaleString()}}</td-c>
              <td-c>75%</td-c>
              <td-c>{{aggregate_contract.shinjuku.purchase_amount.toLocaleString()}}</td-c>
            </tr-c>
            <tr-c slot="tr-th">
              <th-c>大宮</th-c>
              <td-c>{{aggregate_contract.oomiya.amount.toLocaleString()}}</td-c>
              <td-c>75%</td-c>
              <td-c>{{aggregate_contract.oomiya.purchase_amount.toLocaleString()}}</td-c>
            </tr-c>
            <tr-c slot="tr-th">
              <th-c>高松</th-c>
              <td-c>{{aggregate_contract.takamatsu.amount.toLocaleString()}}</td-c>
              <td-c>77%</td-c>
              <td-c>{{aggregate_contract.takamatsu.purchase_amount.toLocaleString()}}</td-c>
            </tr-c>
            <tr-c slot="tr-th">
              <th-c>高崎</th-c>
              <td-c>{{aggregate_contract.takasaki.amount.toLocaleString()}}</td-c>
              <td-c>75%</td-c>
              <td-c>{{aggregate_contract.takasaki.purchase_amount.toLocaleString()}}</td-c>
            </tr-c>
            <tr-c slot="tr-th">
              <th-c>合計</th-c>
              <td-c>{{aggregate_contract.sum.amount.toLocaleString()}}</td-c>
              <td-c>75%</td-c>
              <td-c>{{aggregate_contract.sum.purchase_amount.toLocaleString()}}</td-c>
            </tr-c>
          </table-c>
        </div>

        <div>
          <bar-chart
            :styles="myStyles"
            :chart-data="datacollection"
            :options="options"
          ></bar-chart>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { getAPIURL } from '@/store/getters.js'
const url = getAPIURL() + '/api/v1/aggregate_contracts'

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  // offset: config.LIMIT,
  // max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'aggregate_contract',
  pageNames: 'aggregate_contracts'
}

import BarChart from '@/components/util/BarChartA.vue'

export default {
  components: {
    BarChart
  },
  data () {
    return {
      datacollection: {},
      options: {
        responsive: true,
        maintainAspectRatio: false
      },
      height: 100,

      search: {
        contract_date: []
      }
    }
  },

  computed: {
    aggregate_contract () {
      return this.$store.getters.aggregate_contract
    },

    myStyles () {
      return {
        height: `calc(${this.height}vh - 450px`,
        position: 'relative'
      }
    }
  },

  // mounted () {
  //   this.fillData()
  // },

  async mounted () {
    this.loaded = false
    try {
      const { userlist } = await fetch('/api/v1/aggregate_contract')
      console.log('api')
      this.chartData = userlist
      this.loaded = true
    } catch (e) {
      console.error(e)
    }
  },

  methods: {
    fillData () {
      this.datacollection = {
        labels: ['仙台', '札幌', '名古屋', '福岡', '新宿', '大宮', '高松', '高崎'],
        datasets: [
          {
            type: 'bar',
            // fill: false,
            label: '売上',
            backgroundColor: 'rgba(252, 121, 118, 1)',
            // strokeColor: 'black',
            // borderColor: '#ccc',
            // borderWidth: 1,
            data: [
              this.aggregate_contract.sendai.amount,
              this.aggregate_contract.sapporo.amount,
              this.aggregate_contract.nagoya.amount,
              this.aggregate_contract.fukuoka.amount,
              this.aggregate_contract.shinjuku.amount,
              this.aggregate_contract.oomiya.amount,
              this.aggregate_contract.takamatsu.amount,
              this.aggregate_contract.takasaki.amount
            ]
          },
          {
            type: 'bar',
            // fill: false,
            label: '営業所売上',
            backgroundColor: 'rgba(33, 150, 243, 1)',
            // strokeColor: 'black',
            // borderColor: '#ccc',
            // borderWidth: 1,
            data: [
              this.aggregate_contract.sendai.pure_amount,
              this.aggregate_contract.sapporo.pure_amount,
              this.aggregate_contract.nagoya.pure_amount,
              this.aggregate_contract.fukuoka.pure_amount,
              this.aggregate_contract.shinjuku.pure_amount,
              this.aggregate_contract.oomiya.pure_amount,
              this.aggregate_contract.takamatsu.pure_amount,
              this.aggregate_contract.takasaki.pure_amount
            ]
          }
        ]
      }
      this.options = {
        responsive: true,
        maintainAspectRatio: false,
        showAllTooltips: true,
        scales: {
          xAxes: [
            {
              ticks: {}
            }
          ],
          yAxes: [
            {
              ticks: {
                // min: 0,
                // max: 10000000,
                // stepSize: 5000000,
                callback: (label, index, labels) => {
                  return label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' 円'
                }
              }
            }
          ]
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              return tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' 円'
            }
          }
        }
      }
    },
    searchTable (e) {
      let that = this
      let search = this.search
      var store = this.$store
      var params = {}
      function searchTable () {
        // aggregate
        var paramsList = [
          'contract_date'
        ]
        paramsList.forEach((e) => {
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else {
            params[e] = [search[e][0]]
          }
        })
        axios.get(obj.url, {params: params, withCredentials: true})
        .then((response) => {
        // success callback
          console.log(response)
          store.state.item.aggregate_contract = response.data
          that.fillData()
        }, (response) => {
        // error callback
        })
      }

      if (obj.TIMER) {
        clearTimeout(obj.TIMER)
        obj.TIMER = setTimeout(searchTable, obj.wait)
        return
      }
      obj.TIMER = setTimeout(searchTable, obj.wait)
    },

    getAggregateContract () {
      this.$store.dispatch('getAggregateContract')
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getAggregateContract()

      const year = new Date().getFullYear()
      const month = ('0' + (new Date().getMonth() + 1)).slice(-2)
      vm.search.contract_date.push(year + '-' + month)
      setTimeout(() => {
        vm.searchTable()
      }, 150)
    })
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  .list-box {
    margin-bottom: 15px;
  }
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
</style>



// WEBPACK FOOTER //
// AggregatesContracts.vue?6485716c